import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

const TournamentRouteContext = createContext(null);

export const TournamentRouteProvider = ({
  tournamentId,
  slug,
  children,
}) => (
  <TournamentRouteContext.Provider value={{ tournamentId, slug }}>
    {children}
  </TournamentRouteContext.Provider>
);

export const useTournamentRoute = () => useContext(TournamentRouteContext);

export const useTournamentId = () => {
  const route = useTournamentRoute();
  const { tournamentId } = useParams();
  return route?.tournamentId || tournamentId;
};

export const useTournamentSlug = () => {
  const route = useTournamentRoute();
  const { tournamentId } = useParams();
  return route?.slug || tournamentId;
};
